module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-700-404.9bfcdad.woff2";